import "babel-polyfill";
import { login } from "./login/login.state";
import { home } from "./home/home.state";
import { account } from "./account/account.state";
import { shipment } from "./shipment/shipment.state";
import { shipmentDetail } from "./shipmentDetail/shipmentDetail.state";
import { timelog } from "./timelog/timelog.state";
import { arrival } from "./arrival/arrival.state";
import { departure } from "./departure/departure.state";
import { discharge } from "./discharge/discharge.state";
import { pumping } from "./pumping/pumping.state";
import { userlist } from "./userlist/userlist.state";
export const setGlobalParam = "setGlobalParam->GlobalReducer";
export const userLogout = "userLogout->GlobalReducer";
const initialStates = {
  login,
  account,
  home,
  shipment,
  shipmentDetail,
  timelog,
  arrival,
  departure,
  discharge,
  pumping,
  userlist,
  user: {
    email: "",
    company_email: "",
    username: "",
    role: "",
    datecreated: "",
    hq_name: "",
  },
};

export default function reducer(
  state = {
    ...initialStates,
  },
  action
) {
  switch (action.type) {
    case userLogout:
      return initialStates;
    case setGlobalParam: {
      let storage = action.storage;
      if (action.storage.indexOf(".") > -1) {
        let storage_split = storage.split(".");
        let storage_global = storage_split[0];
        let storage_object = storage_split[1];
        if (storage_split.length > 2) {
          let storage_object_1 = storage_split[2];
          return {
            ...state,
            [storage_global]: {
              ...state[storage_global],
              [storage_object]: {
                ...state[storage_global][storage_object],
                [storage_object_1]: action.response,
              },
            },
          };
        }

        return {
          ...state,
          [storage_global]: {
            ...state[storage_global],
            [storage_object]: action.response,
          },
        };
      }

      return {
        ...state,
        [action.storage]: action.response,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducers.js